import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { IgSheet } from '../ig/IgSheet';
import './action-personnes.css';

/* Carte « personnes » (règle listes dans une carte) : chiffre + phrase courte, barre de répartition, lignes (4 max) ou ronds, une solution, un bouton + « Plus tard ». */
const TONE = { lilas: '#B9A6F5', bad: '#C92A2A', warn: '#F0592B', ok: '#A8DDA0' };
const wa = (tel, nom) => `https://wa.me/${String(tel).replace(/\D/g, '')}?text=${encodeURIComponent(`Bonjour ${nom}, tu es attendu(e) sur le service : tu arrives ? Merci de me répondre vite.`)}`;

const Ligne = ({ p, onOpen, testId }) => (
  <div className="acp-ligne" data-testid={testId}>
    <span className="acp-ini">{p.initiales}</span>
    <button type="button" className="acp-txt" onClick={() => onOpen(p)} data-keepicon=""><b>{p.nom}</b><small>{p.sous}</small></button>
    {p.tel ? <a className="acp-relancer" href={wa(p.tel, p.prenom)} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-relancer`}><MessageCircle size={16} /> Relancer</a>
      : <button type="button" className="acp-relancer is-off" onClick={() => onOpen(p)} title="Numéro manquant · ouvrir la fiche" data-testid={`${testId}-relancer`}>Numéro ?</button>}
  </div>
);

export const ActionPersonnes = ({ a, agentName, badge, primary, primaryLabel, onPrimary, onLater, onOpenPerson, testId }) => {
  const d = a.personnes;
  const [voir, setVoir] = useState(null);
  const total = d.repartition.reduce((s, r) => s + r.n, 0) || 1;
  const grp = d.groupes.find((g) => g.key === voir);
  return (
    <div className="acp" data-testid={testId}>
      <header className="acp-head">
        <span className="acp-agent"><b>{(agentName || 'S')[0]}</b></span>
        <div className="min-w-0 flex-1"><p className="acp-nom">{agentName}</p><p className="acp-sous">{a.domaine ? a.domaine.charAt(0).toUpperCase() + a.domaine.slice(1) : 'Équipe'}{a.enjeu ? ` · ${a.enjeu}` : ''}</p></div>
        {badge}
      </header>
      <section className="acp-chiffre" data-testid={`${testId}-chiffre`}>
        <div className="acp-chiffre-row"><b className="acp-big">{d.total}</b><div className="min-w-0"><p className="acp-fact">{a.fact}</p><p className="acp-fact-sous">{d.sous}</p></div></div>
        {d.repartition.length > 1 && <>
          <div className="acp-barre" role="img" aria-label={d.repartition.map((r) => r.label).join(' · ')}>{d.repartition.map((r) => <i key={r.key} style={{ width: `${(r.n / total) * 100}%`, background: TONE[r.tone] || '#C7C7CC' }} />)}</div>
          <p className="acp-legende">{d.repartition.map((r) => <span key={r.key}><i style={{ background: TONE[r.tone] || '#C7C7CC' }} />{r.label}</span>)}</p>
        </>}
      </section>
      {d.groupes.map((g) => (
        <section key={g.key} className="acp-groupe" data-testid={`${testId}-groupe-${g.key}`}>
          <div className="acp-groupe-t"><p>{g.label} · {g.people.length}</p>{g.people.length > (g.mode === 'ronds' ? 7 : 4) && <button type="button" className="acp-voir" onClick={() => setVoir(g.key)} data-testid={`${testId}-voir-${g.key}`}>Voir les {g.people.length} ›</button>}</div>
          {g.mode === 'ronds'
            ? <div className="acp-ronds">{g.people.slice(0, 7).map((p) => <button key={p.id} type="button" className="acp-rond" data-keepicon="" onClick={() => onOpenPerson(p)} data-testid={`${testId}-rond-${p.id}`}><span style={{ boxShadow: `0 0 0 3px #fff, 0 0 0 5px ${TONE[g.tone] || '#C7C7CC'}` }}>{p.initiales}</span><small>{p.prenom}</small></button>)}</div>
            : <div className="acp-lignes">{g.people.slice(0, 4).map((p) => <Ligne key={p.id} p={p} onOpen={onOpenPerson} testId={`${testId}-ligne-${p.id}`} />)}</div>}
        </section>
      ))}
      <footer className="acp-foot">
        {d.solution && <div className="acp-solution"><MessageCircle size={22} className="acp-solution-ico" /><div><p>{d.solution.titre}</p><small>{d.solution.sous}</small></div></div>}
        <div className="acp-btns">
          {primary && <button type="button" className="acp-primary" onClick={onPrimary} data-testid={`action-btn-${primary.action_id}`}>{primaryLabel}</button>}
          <button type="button" className="acp-later" onClick={onLater} data-testid={`${testId}-plus-tard`}>Plus tard</button>
        </div>
      </footer>
      <IgSheet open={!!grp} onClose={() => setVoir(null)} title={grp ? `${grp.label.charAt(0)}${grp.label.slice(1).toLowerCase()} · ${grp.people.length}` : ''} kicker={d.sous} testId={`${testId}-sheet`}>
        <div className="acp-lignes is-sheet">{(grp?.people || []).map((p) => <Ligne key={p.id} p={p} onOpen={(x) => { setVoir(null); onOpenPerson(x); }} testId={`${testId}-sheet-ligne-${p.id}`} />)}</div>
      </IgSheet>
    </div>
  );
};
